<template>
  <div :class="className">
    <!--操作-->
    <div class="space-between">
      <!--搜索项表单-->
      <h-form
        :form="search['form']"
        :option="search['option']"
        :size="search['size'] || size"
        :label-width="search['labelWidth']"
        :rules="search['rules']"
        :form-width="search['formWidth']"
        :item-width="search['itemWidth']"
        :class-name="search['className']"
        @change="searchChange"
      />
      <!--操作按钮项表单-->
      <h-form
        :option="operationOption"
        :form="operation['form'] || {}"
        :author="author"
        :size="operation['size'] || size"
        :label-width="operation['labelWidth']"
        :form-width="operation['formWidth']"
        :item-width="operation['itemWidth'] || 'fit-content'"
        :class-name="operation['className'] || 'ML10'"
      >
        <template v-slot="data">
          <!--导出-->
          <h-export
            :loading="exportOption['loading']"
            :export-list="exportOption['list']"
            :prop="exportOption['prop']"
            :placement="exportOption['placement']"
            @exportUpd="exportUpd"
            @exportDel="exportDel"
            @setExport="setExport(data)"
          />
        </template>
      </h-form>
    </div>
    <!--表格-->
    <el-table
      ref="crudTable"
      v-loading="loading"
      :data="data"
      :size="size"
      :fit="TRUE(option['fit'])"
      :border="TRUE(option['border'])"
      :height="option['height']"
      :max-height="option['maxHeight']"
      :show-summary="FALSE(option['summary'])"
      :summary-method="getSummaries"
      :highlight-current-row="FALSE(option['currentRow'])"
      :element-loading-text="LoadingText(option['LoadingText'])"
      :element-loading-spinner="loadingIcon(option['loadingIcon'])"
      @selection-change="selectionChange"
    >
      <el-table-column
        v-if="FALSE(option['tableSelection'])"
        type="selection"
        align="center"
        :fixed="TRUE(option['tableSelectionFixed'])"
        :width="option['tableSelectionWidth'] || 80"
        :selectable="option['tableSelectable']"
      />
      <el-table-column
        v-if="FALSE(option['tableIndex'])"
        type="index"
        align="center"
        :fixed="TRUE(option['tableIndexFixed'])"
        :width="option['tableIndexWidth'] || 80"
        :label="option['tableIndexLabel'] || '序号'"
      />
      <el-table-column
        v-for="item in option['column']"
        :key="item.index"
        :label="item.label"
        :prop="item.prop"
        :width="item.width"
        :align="item.align"
        :fixed="item.fixed"
      >
        <template v-slot="scoped">
          <slot v-if="item.useSlot" :data="{...scoped,columnItem:item,name:'table'}"/>

          <span v-else-if="item.tag" :class="scoped.row[item.prop] !== '' ? '' : 'no-tag'">
            <el-tag v-if="item.unit" :size="item.size || size" :type="tagType(item,scoped.row)"
                    @click="click(item,scoped.row)" :class="item['className']">
              {{ scoped.row[item.prop] + item.unit }}
            </el-tag>

            <el-tag v-else-if="item.option" :size="item.size || size" :type="tagType(item,scoped.row)"
                    @click="click(item,scoped.row)" :class="item['className']">
              {{ findVal(item, scoped.row) }}
            </el-tag>

            <el-tag v-else :size="item.size || size" :type="tagType(item,scoped.row)" @click="click(item,scoped.row)"
                    :class="item['className']">
              {{ scoped.row[item.prop] }}
            </el-tag>
          </span>

          <span v-else-if="item.unit" :class="item['className']" @click="click(item,scoped.row)">
            {{ scoped.row[item.prop] + item.unit }}
          </span>

          <el-select
            v-else-if="item.select"
            filterable
            default-first-option
            v-model="scoped.row[item.prop]"
            @change="change(item,scoped.row)"
            @blur="blur($event,item)"
            :placeholder="item.placeholder || `请选择${item.label}`"
            :clearable="TRUE(item.clearable)"
            :disabled="item.disabled"
            :allow-create="FALSE(item.allowCreate)"
            :style="{'width':VW(item.itemWidth) || 'fit-content'}"
            :multiple="FALSE(item.multiple)"
            :value-key="item.valueKey"
            :size="item.size || size"
          >
            <el-option
              v-for="val in item.option"
              :key="val[item['optionKey']] || val.index"
              :label="val[item['optionVal']] || val"
              :disabled="val.disabled"
              :value="selectValue(item,val)"
            />
          </el-select>

          <span v-else-if="item.date">
            {{ date(scoped.row[item.prop]) }}
          </span>

          <span v-else-if="item.datetime">
            {{ datetime(scoped.row[item.prop]) }}
          </span>

          <span v-else-if="item.option" :class="item['className']" @click="click(item,scoped.row)">
            {{ findVal(item, scoped.row) }}
          </span>

          <template v-else-if="item.preview">
            <h-preview
              v-if="scoped.row[item.prop]"
              :url="previewUrl(scoped.row[item.prop])"
              :url-list="previewUrlLIst(scoped.row[item.prop])"
              :width="item['previewWidth']"
              :height="item['previewHeight']"
            />
          </template>

          <el-button
            v-else-if="item.button"
            @click="item.click(scoped.row)"
            :plain="TRUE(item.plain)"
            :size="item.size || size"
            :type="item.type || 'primary'">
            <i :class="item.icon"/>
            {{ item.content }}
          </el-button>

          <span :class="item['className']" @click="click(item,scoped.row)" v-else>
            {{ scoped.row[item.prop] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        :width="option['operationWidth'] || 250"
        :label="option['operationLabel'] || '操作'"
        align="center"
        fixed="right"
        v-if="operationShow"
      >
        <template v-slot="scope">
          <div class="flex-center">
            <!--表格操作按钮项表单-->
            <h-form
              center
              :option="tableOperationOption"
              :form="scope.row"
              :author="author"
              :size="option['size'] || size"
              :label-width="option['labelWidth']"
              :form-width="option['formWidth']"
              :item-width="option['itemWidth'] || 'fit-content'"
              :class-name="option['className'] || 'MX5'"
            />

            <slot name="operation" :data="{...scope}"/>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <h-paging
      v-if="total >= 0"
      :total="total"
      :page.sync="PAGE"
      :limit.sync="LIMIT"
      @pagination="pagingChange"
    />
    <!--新增-->
    <el-dialog
      append-to-body
      v-dialog-drag
      v-if="addDialog"
      :title="addDialog['title'] || '新增'"
      :width="VW(addDialog['width']) || '18%'"
      :visible.sync="addDialogVisible"
      @close="close('addForm')"
      :close-on-click-modal="false"
      :top="addDialog.top"
    >
      <h-form
        ref="addForm"
        :form="addDialog['form']"
        :option="addDialog['option']"
        :size="addDialog['size'] || size"
        :label-width="addDialog['labelWidth']"
        :rules="addDialog['rules']"
        :formWidth="addDialog['formWidth']"
        :itemWidth="addDialog['itemWidth']"
        :class-name="addDialog['className']"
        @change="dialogChange"
      >
        <template v-slot="data">
          <slot v-if="data.data.item.type === 'slot'" :data="{...data,name:'dialog'}"/>
        </template>
      </h-form>
      <div slot="footer">
        <el-button
          @click="addDialogVisible = false"
          v-if="TRUE(addDialog['confirmBtn'])"
          :size="addDialog['confirmBtnSize'] || size"
          :type="addDialog['confirmBtnType']"
        >
          {{ addDialog['confirmBtnName'] || "取消" }}
        </el-button>
        <el-button
          @click="addSubmit('addForm')"
          v-if="TRUE(addDialog['cancelBtn'])"
          :size="addDialog['cancelBtnSize'] || size"
          :type="addDialog['cancelBtnType'] || 'primary'"
        >
          {{ addDialog['cancelBtnName'] || "确定" }}
        </el-button>
      </div>
    </el-dialog>
    <!--修改-->
    <el-dialog
      append-to-body
      v-dialog-drag
      v-if="result.updDialog"
      :title="result.updDialog.title || '编辑'"
      :width="VW(result.updDialog.width) || '18%'"
      :visible.sync="updDialogVisible"
      @close="close('updForm')"
      :close-on-click-modal="false"
      :top="result.updDialog.top"
    >
      <h-form
        ref="updForm"
        :disabled="view"
        :form="result.updDialog.form"
        :option="result.updDialog.option"
        :size="result.updDialog.size || size"
        :label-width="result.updDialog.labelWidth"
        :rules="result.updDialog.rules"
        :formWidth="result.updDialog.formWidth"
        :itemWidth="result.updDialog.itemWidth"
        :class-name="result.updDialog['className']"
        @change="dialogChange"
      >
        <template v-slot="data">
          <slot v-if="data.data.item.type === 'slot'" :data="{...data,name:'dialog'}"/>
        </template>
      </h-form>
      <div slot="footer">
        <el-button
          @click="updDialogVisible = false"
          v-if="TRUE(result.updDialog['confirmBtn'])"
          :size="result.updDialog['confirmBtnSize'] || size"
          :type="result.updDialog['confirmBtnType']"
        >
          {{ result.updDialog['confirmBtnName'] || "取消" }}
        </el-button>
        <el-button
          @click="updSubmit('updForm')"
          v-if="TRUE(result.updDialog['cancelBtn'])"
          :size="result.updDialog['cancelBtnSize'] || size"
          :type="result.updDialog['cancelBtnType'] || 'primary'"
        >
          {{ result.updDialog['cancelBtnName'] || "确定" }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {validator, type} from "otb-module/src/utils/tool";

export default {
  name: "hCrud",
  props: {
    search: {
      type: Object,
      required: false,
      default: () => {
        return {
          option: [],
          form: {}
        }
      },
    },
    operation: {
      type: Object,
      required: false,
      default: () => {
        return {}
      },
    },
    exportOption: {
      type: Object,
      required: false,
      default: () => {
        return {
          open: false,
          modal: false,
          list: [],
          prop: {}
        }
      },
    },
    data: {
      type: Array,
      required: true,
      default: () => {
        return [];
      },
    },
    option: {
      type: Object,
      default: () => {
        return {};
      },
    },
    size: {
      type: String,
      required: false,
      default: "small"
    },
    className: {
      type: String,
      required: false,
      default: "M25 P20 shadow"
    },
    loading: {
      type: Boolean,
      required: false
    },
    total: {
      type: Number,
      required: false
    },
    limit: {
      type: Number,
      required: false
    },
    page: {
      type: Number,
      required: false
    },
    addDialog: {
      type: Object,
      required: false
    },
    updDialog: {
      type: Object,
      required: false
    },
    beforeRowAdd: {
      type: Function,
      default: () => {
        return new Promise((resolve) => {
          resolve(true);
        });
      },
    },
    beforeRowUpd: {
      type: Function,
      default: () => {
        return new Promise((resolve) => {
          resolve(true);
        });
      },
    },
    author: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    tagType() {
      return (item, row) => {
        if (type(item["tagType"]) === "Array") {
          return item["tagType"].find(v => v.key === row[item.prop]).val;
        }
        if (type(item["tagType"] === "String")) {
          return item["tagType"];
        }
      };
    },
    operationShow() {
      if (this.option['operationShow'] === true) return true
      let show = this.TRUE(this.option['operationShow']);
      let dataLength = this.data.length > 0;
      let l = 0;
      for (let o of this.tableOperationOption) if (o.show === false) l += 1;
      let hasOperationItem = this.tableOperationOption.length > l;
      return show && dataLength && hasOperationItem;
    },
    TRUE() {
      return item => {
        return [true, false].includes(item) ? item : true
      }
    },
    FALSE() {
      return item => {
        return [true, false].includes(item) ? item : false
      }
    },
    LoadingText() {
      return item => {
        return item ? item : "拼命加载中"
      }
    },
    loadingIcon() {
      return item => {
        return item ? item : "el-icon-loading"
      }
    },
    LIMIT: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit("update:limit", val)
      }
    },
    PAGE: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit("update:page", val)
      }
    },
    exportOpen: {
      get() {
        return this.exportOption
      },
      set(val) {
        this.$emit('update:exportOption', val)
      }
    },
    date() {
      return item => {
        return this.$time.date(item);
      };
    },
    datetime() {
      return item => {
        return this.$time.datetime(item);
      };
    },
    findVal() {
      return (item, row) => {
        let optionKey = item['optionKey'] || "key";
        let optionVal = item['optionVal'] || "val";
        let noKeyMsg = item["noKeyMsg"] || "";
        if (item.option.find(v => v[optionKey] === row[item.prop])) {
          return item.option.find(v => v[optionKey] === row[item.prop])[optionVal];
        } else {
          return noKeyMsg;
        }
      };
    },
    VW() {
      return v => {
        if (type(v) === "Number") return v + "vw";
        return v;
      };
    },
    selectValue() {
      return (item, val) => {
        if (item.valueKey) return val;
        if (item['optionKey']) {
          return val[item['optionKey']];
        } else {
          return val;
        }
      }
    },
    previewUrl() {
      return item => {
        if (type(item) === "Array") return item.length > 0 ? item[0] : "";
        return item;
      };
    },
    previewUrlLIst() {
      return item => {
        if (type(item) === "Array") return item;
        return item ? [item] : [];
      };
    },
  },
  data() {
    return {
      view: false,
      operationOption: [
        {
          key: "add",
          type: "button",
          content: "新增",
          show: true,
          click: () => this.beforeAdd()
        },
        {
          key: "export",
          type: "slot",
          content: "导出",
          show: false
        }
      ],
      tableOperationOption: [
        {
          key: "view",
          type: "button",
          content: "详情",
          plain: true,
          show: false,
          click: (e) => this.beforeView(e)
        },
        {
          key: "upd",
          type: "button",
          content: "编辑",
          plain: true,
          show: true,
          click: (e) => this.beforeUpd(e)
        },
        {
          key: "del",
          type: "button",
          content: "删除",
          show: true,
          btnType: "danger",
          plain: true,
          click: (e) => this.rowDel(e)
        },
      ],
      addDialogVisible: false,
      updDialogVisible: false,
      result: {
        updDialog: {}
      }
    }
  },
  watch: {
    updDialog: {
      handler(newVal) {
        this.result.updDialog = newVal;
      },
      deep: true,
      immediate: true
    },
    option: {
      handler(newVal) {
        if (newVal["viewBtn"]) {
          this.tableOperationOption[0] = {...this.tableOperationOption[0], ...newVal["viewBtn"]};
        }
        if (newVal["updBtn"]) {
          this.tableOperationOption[1] = {...this.tableOperationOption[1], ...newVal["updBtn"]};
        }
        if (newVal["delBtn"]) {
          this.tableOperationOption[2] = {...this.tableOperationOption[2], ...newVal["delBtn"]};
        }
        if (newVal["customBtn"]) {
          this.tableOperationOption = [...this.tableOperationOption, ...newVal["customBtn"]];
        }
        this.tableOperationOption = [...new Set(this.tableOperationOption)];
      },
      deep: true,
      immediate: true
    },
    operation: {
      handler(newVal) {
        if (newVal["addBtn"]) {
          this.operationOption[0] = {...this.operationOption[0], ...newVal["addBtn"]};
        }
        if (newVal["exportBtn"]) {
          this.operationOption[1] = {...this.operationOption[1], ...newVal["exportBtn"]};
        }
        if (newVal["customBtn"]) {
          this.operationOption = [...newVal["customBtn"], ...this.operationOption];
        }
        this.operationOption = [...new Set(this.operationOption)];
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    searchChange(e) {
      this.$emit("searchChange", e)
    },
    pagingChange(e) {
      this.$emit("pagingChange", e)
    },
    dialogChange(e) {
      this.$emit("dialogChange", e)
    },
    beforeAdd() {
      this.$emit("beforeAdd")
      this.addDialogVisible = true
    },
    addSubmit(ref) {
      this.$refs[ref].$refs.hForm["validate"]((valid) => {
        if (valid) {
          if (this.addDialog["hasValRules"] && this.addDialog["hasValRules"].length > 0) {
            for (let item of this.addDialog["hasValRules"]) {
              if (this.addDialog.form[item.prop]) {
                let valid = validator(this.addDialog.form[item.prop], item.type);
                if (type(valid) === "String") {
                  this.$message.warning(valid);
                  return;
                }
                if (type(valid) === "Boolean" && !valid) {
                  this.$message.warning(item.message);
                  return;
                }
              }
            }
          }

          this.beforeRowAdd(this.addDialog.form).then(e => {
            if (!e) return e;
            this.addDialogVisible = false;
            this.$emit("rowAdd", this.addDialog.form);
          });
        }
      });
    },
    beforeView(row) {
      this.view = true;
      this.result.updDialog.form = {...row}
      this.$emit("beforeView", row)
      this.updDialogVisible = true
    },
    beforeUpd(row) {
      this.view = false;
      this.result.updDialog.form = {...row}
      this.$emit("beforeUpd", row)
      this.updDialogVisible = true
    },
    updSubmit(ref) {
      this.$refs[ref].$refs.hForm["validate"]((valid) => {
        if (valid) {
          if (this.updDialog["hasValRules"] && this.updDialog["hasValRules"].length > 0) {
            for (let item of this.result.updDialog["hasValRules"]) {
              if (this.updDialog.form[item.prop]) {
                let valid = validator(this.updDialog.form[item.prop], item.type);
                if (type(valid) === "String") {
                  this.$message.warning(valid);
                  return;
                }
                if (type(valid) === "Boolean" && !valid) {
                  this.$message.warning(item.message);
                  return;
                }
              }
            }
          }

          this.beforeRowUpd(this.updDialog.form).then(e => {
            if (!e) return e;
            this.updDialogVisible = false
            this.$emit("rowUpd", this.result.updDialog.form);
          });
        }
      });
    },
    rowDel(row) {
      this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit("rowDel", row);
      }).catch(() => {
        this.$message({type: "info", message: "已取消"})
      });
    },
    close(ref) {
      this.$refs[ref].$refs.hForm["clearValidate"]()
      this.$emit("close")
    },
    getSummaries(param) {
      const {columns} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计"
          return
        }
        for (let item of this.option["summaryList"]) {
          if (column.property === item) {
            sums[index] = this.option["summaryFields"][column.property]
          }
        }
      })

      return sums
    },
    selectionChange(val) {
      this.$emit("selectionChange", val);
    },
    setExport(o) {
      this.$emit("setExport", o);
    },
    exportUpd(e) {
      this.$emit("exportUpd", e);
    },
    exportDel(e) {
      this.$emit("exportDel", e);
    },
    change(v, row) {
      if (v && type(v.change) === "Function") v.change(row);
    },
    blur(e, v) {
      if (v && type(v.blur) === "Function") v.blur(e);
    },
    click(v, row) {
      if (v && type(v.click) === "Function") v.click(row);
      this.$emit("click", row);
    }
  }
}
</script>
